import React, { useMemo } from 'react';
import classNames from 'classnames';
import usePastTime from 'hooks/usePastTime';
import { useTranslation } from 'react-i18next';
import { NDA_COPIES, NDA_ICON } from './data';
import {
  DATA_ROOM_NDA_SIGNING_STATUS,
  DataRoomNdaSigningStatus,
} from 'router/subrouters/DataRoom/models/DataRoomNDA';
import ResolvePopup from 'components/ResolvePopup';
import TransWithNda from 'components/TransWithNda';
import TruncatedText from 'components/TruncatedText';

import './DataRoomNdaStatusBadge.styles.scss';

type DataRoomNdaStatusBadgeProps = {
  className?: string;
  status: DataRoomNdaSigningStatus;
  signedDate?: Date;
  sentDate?: Date;
  rejectionReason?: string;
  envelopeTemplateName: string;
  onClick?: () => void;
};

const DataRoomNdaStatusBadge: React.FC<DataRoomNdaStatusBadgeProps> = (
  props,
) => {
  const {
    className,
    status,
    signedDate,
    sentDate,
    rejectionReason,
    envelopeTemplateName,
    onClick,
  } = props;

  const classes = classNames(
    'data-room-nda-status-badge',
    status,
    { clickable: onClick },
    className,
  );

  const Icon = useMemo(() => NDA_ICON[status], [status]);

  const pastTime = usePastTime();

  const { t } = useTranslation();

  return (
    <ResolvePopup
      onHover
      className="data-room-nda-status-badge-popup"
      popupContent={
        <div className="data-room-nda-status-badge-popup__content">
          <TransWithNda
            className="nda-status-copy"
            i18nKey={NDA_COPIES[status]}
            envelopeTemplateName={envelopeTemplateName}
          />

          {status === DATA_ROOM_NDA_SIGNING_STATUS.REJECTED ? (
            rejectionReason && <p>{rejectionReason}</p>
          ) : signedDate ? (
            <p>{pastTime(signedDate)}</p>
          ) : (
            sentDate && <p>{pastTime(sentDate)}</p>
          )}
        </div>
      }
    >
      <div
        className={classes}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.();
        }}
      >
        {envelopeTemplateName ? (
          <TruncatedText text={envelopeTemplateName} />
        ) : (
          t('nda')
        )}
        <Icon />
      </div>
    </ResolvePopup>
  );
};

export default DataRoomNdaStatusBadge;
